//-- copyright
// OpenProject is an open source project management software.
// Copyright (C) the OpenProject GmbH
//
// This program is free software; you can redistribute it and/or
// modify it under the terms of the GNU General Public License version 3.
//
// OpenProject is a fork of ChiliProject, which is a fork of Redmine. The copyright follows:
// Copyright (C) 2006-2013 Jean-Philippe Lang
// Copyright (C) 2010-2013 the ChiliProject Team
//
// This program is free software; you can redistribute it and/or
// modify it under the terms of the GNU General Public License
// as published by the Free Software Foundation; either version 2
// of the License, or (at your option) any later version.
//
// This program is distributed in the hope that it will be useful,
// but WITHOUT ANY WARRANTY; without even the implied warranty of
// MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
// GNU General Public License for more details.
//
// You should have received a copy of the GNU General Public License
// along with this program; if not, write to the Free Software
// Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
//
// See COPYRIGHT and LICENSE files for more details.
//++

import { Injectable, inject } from '@angular/core';
import { WorkPackageResource } from 'core-app/features/hal/resources/work-package-resource';
import {
  WorkPackageInlineCreateService,
} from 'core-app/features/work-packages/components/wp-inline-create/wp-inline-create.service';
import { IsolatedQuerySpace } from 'core-app/features/work-packages/directives/query-space/isolated-query-space';
import { HalResourceService } from 'core-app/features/hal/services/hal-resource.service';
import {
  BoardInlineAddAutocompleterComponent,
} from 'core-app/features/boards/board/inline-add/board-inline-add-autocompleter.component';
import { Observable } from 'rxjs';

@Injectable()
export class BoardInlineCreateService extends WorkPackageInlineCreateService {
  protected readonly querySpace = inject(IsolatedQuerySpace);
  protected readonly halResourceService = inject(HalResourceService);

  /**
   * A separate reference pane for the inline create component
   */
  public readonly referenceComponentClass = BoardInlineAddAutocompleterComponent;

  /**
   * A related work package for the inline create context
   */
  public referenceTarget:WorkPackageResource|null = null;

  public get canAdd():Observable<boolean> {
    return this
      .currentUser
      .hasCapabilities$(
        ['work_packages/create'],
        this.currentProject.id || 'global',
      );
  }

  public get canReference():Observable<boolean> {
    return this
      .currentUser
      .hasCapabilities$(
        ['work_packages/update'],
        this.currentProject.id || 'global',
      );
  }

  /**
   * Reference button text
   */
  public readonly buttonTexts = {
    reference: this.I18n.t('js.relation_buttons.add_existing_child'),
    create: this.I18n.t('js.relation_buttons.add_new_child'),
  };
}
